module.exports = __webpack_public_path__ + "static/media/card_2x.72e2b276.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/chicago/card_2x.jpg
// module id = 887
// module chunks = 27